
import { createContext, useReducer, useEffect } from "react";
import EnvoieReducer from "./EnvoieReducer";

const INITIAL_STATE = {
  envois: [],
  count: 1,
  isFetching: false,
  error: false,
  envoie: {},
  isFetchingGet: false,
  errorGet: false,
  historyCases: [],
  isFetchingCases: false,
  errorCases: false,
  historyCaseAdd: {},
  isFetchingCaseAdd: false,
  errorCaseAdd: false,
  pageNumber: JSON.parse(localStorage.getItem('pageNumber')) || 1,
};


export const EnvoieContext = createContext(INITIAL_STATE);

export const EnvoieContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(EnvoieReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("pageNumber", JSON.stringify(state.pageNumber))
  }, [state.pageNumber])

  return (
    <EnvoieContext.Provider
      value={{
        envois: state.envois,
        count: state.count,
        isFetching: state.isFetching,
        error: state.error,
        envoie: state.envoie,
        isFetchingGet: state.isFetchingGet,
        errorGet: state.errorGet,
        historyCases: state.historyCases,
        isFetchingCases: state.isFetchingCases,
        errorCases: state.errorCases,
        historyCaseAdd: state.historyCaseAdd,
        isFetchingCaseAdd: state.isFetchingCaseAdd,
        errorCaseAdd: state.errorCaseAdd,
        pageNumber: state.pageNumber,
        dispatch,
      }}
    >
      {children}
    </EnvoieContext.Provider>
  );
};